import React, {ReactElement} from "react";

import './Button.scss'

type Props = {
  children: ReactElement | string
  size?: 'sm' | 'md' | 'lg'
  primary?: boolean
  disabled?: boolean
  ariaLabel?: string
  autoFocus?: boolean
  onClick?: (e: any) => void
}

export default (props: Props) => {
  const classNames = ['button', `size-${props.size || 'sm'}`]
  if (props.primary) {
    classNames.push('primary')
  }

  return (
    <button
      className={classNames.join(' ')}
      onClick={props.onClick}
      disabled={props.disabled || false}
      aria-label={props.ariaLabel}
      autoFocus={props.autoFocus}
    >
      {props.children}
    </button>
  )
}